export default __webpack_public_path__ + "static/isoqar-9752556450f0e38917a39d548aa16a2b.png";